import { useTranslation } from 'react-i18next';

import AddBoxIcon from '@mui/icons-material/AddBox';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


interface CreateNewProps {
  label?: string;
}

const CreateNew = ({ label }: CreateNewProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
      <AddBoxIcon sx={{ color: '#00843D' }} />

      <Typography
        variant="body2"
        sx={{
          color: 'var(--Text-text-primary, #101c16)',
          fontFeatureSettings: "'liga' off, 'clig' off",
          fontFamily: "var(--font-family-helvetica-now, 'Helvetica Now For Cargill')",
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: '18px'
        }}
      >
        {label || t('buttons.createNew')}
      </Typography>
    </Box>
  );
};

export default CreateNew;
